import r from "@brazilian-utils/helper-only-numbers";

var n = function n(r, _n) {
  for (var t = [], e = 0; e < _n; e++) {
    t.push(r - e);
  }

  return t;
},
    t = function t(r, n) {
  return r.split("").reduce(function (r, t, e) {
    return r + parseInt(t, 10) * n[e];
  }, 0);
};

export default function (e, u) {
  var o = r(e);

  if (u.constructor === Number) {
    var i = n(u, o.length);
    return t(o, i);
  }

  if (u.constructor === Array) return t(o, u);
  throw new Error("Invalid weight type. Should be an Array like or a Number");
}
;